<template lang="pug">
  div(:class="{'parent--container':isParent, 'my--container': isMe, 'qcw-group': isGroupRoom, 'contain-date': showDate, 'deleted': isDeleted }")
    div(class='qcw-comment-container' :id="comment.id" :class="{[`qcw-comment--${this.comment.type}`]: true,'comment--me': isMe, 'qcw-comment--cust': isCustomer, 'qcw-comment--sticker': isSticker}")
      div(v-if="showDate" class="qcw-comment-date" :class="{'extra-margin': addExtraMargin}")
        div {{ dateToday }}
      div(v-if="comment.type == 'system_event'" class="qcw-comment--system-event")
        comment-custom(v-if="core.customTemplate && haveTemplate(comment)" :data="comment")
        div(v-else)
          div {{unsanitizeHTML(comment.time+" - "+ comment.message) }}
      div(
        class="qcw-comment"
        v-if="comment.type != 'system_event'"
        :class="{ 'comment--me': isMe, 'comment--parent': isParent, 'comment--mid': isMid, 'comment--last': isLast }"
      )
        avatar(:src="commentAvatar(avatar)" :class="{'qcw-avatar--hide': !isParent}")

        div(class="qcw-comment__message"
          :style="messageStyle"
          :class="{'message__bot': isReplayBot,'extra-margin carousel': comment.type === 'carousel','sticker':isSticker  && !isStickerAds,'card':comment.type === 'card','hover-effect':!isDeleted && !isCustomBuble && !isSticker, 'qcw-comment-prevsession':isPreviousSessionMessageNotifier}")

          //- Only for buble tip, for supporting js styling
          div.tip(
            :style="tipMessageStyle"
          )

          //- Comment User
          //- span(class="qcw-comment__username" v-if="isParent && isGroupRoom && !isMe") {{comment.username_as}}
          span(class="qcw-comment__username" :class="{'qcw-comment__username--hide': isMe}" v-if="isParent" v-html="sanitizeHTML(username)")


          //- reply button
          i(@click="replyHandler(comment)" class="reply-btn" :class="{'reply-btn--me': isMe}" v-if="!isDeleted && !isMe && !isSticker")
            icon(name="ic-reply")

          //- more vertical button
          i(class="qcw-comment__more" @click="menuMoreClicked(comment.id)" v-if="isMe && !isDeleted")
            icon(name="ic-more-horiz")

          div(
            :key="`comment_${comment.id}`"
            ref="`more_${comment.id}`"
            class="qcw-comment__more--menu"
            v-if="isMe && !isDeleted && showMenuMore && !isSticker"
            v-click-outside="onClickMenuOutside"
            )
            ul(v-if="!comment.isFailed")
              li(@click="replyHandler(comment)") Reply

          //- from fb ads
          div(v-if="isFbAdsComment")

            comment-fb-ads(:comment="comment")

              //- CommentType: "TEXT"
              div(class="comment-text" v-if="(comment.type == 'text' || comment.type == 'reply') && !isSticker && !isInteractiveListMessage && !isInteractiveQuickReply && !isPreviousSessionMessageNotifier")
                image-loader(v-if="comment.isAttachment(comment.message) && comment.type != 'reply'"
                  :comment="comment"
                  :message="comment.message"
                  :on-click-image="onClickImage"
                  :callback="onupdate")

                comment-reply(v-if="comment.type =='reply'"
                  :comment="comment"
                  :isMe="isMe"
                  :clickHandler="gotoComment"
                  :onClickImage="onClickImage"
                  :callback="onupdate")

                comment-render(:text="comment.message" v-if="!comment.isAttachment(comment.message) && comment.type=='text'")

              //- CommentType: "file_attachment"
              file-attachment(v-if="comment.type == 'file_attachment'"
                :comment="comment"
                :on-click-image="onClickImage"
                :callback="onupdate")

              //- CommentCustom: "sticker"
              div(class="comment-sticker" v-if="comment.type == 'text' && isSticker")
                image-loader(v-if="isSticker"
                  :comment="comment"
                  :message="comment.message.replace('[sticker]','[file]').replace('[/sticker]','[/file]')"
                  :callback="onupdate")
                
              //- CommentType: "location"
              static-map(:lat="comment.payload.latitude"
                :lng="comment.payload.longitude"
                :name="comment.payload.name"
                :mapkey="core.googleMapKey"
                :message="comment.message"
                :mapurl="comment.payload.map_url"
                v-if="comment.type == 'location'")

              span(class="qcw-comment__time qcw-comment__time--children"
                v-if="!isParent"
                :class="{'qcw-comment__time--attachment': comment.isAttachment(comment.message)}") {{comment.time}}

              span(class="qcw-comment__time"
                :class="{'qcw-comment__time--me': isMe}"
                v-if="!isMe"
                :style="messageTimeStyle") {{comment.time}}

              span(class="qcw-comment__time" v-else) {{comment.time}}
            
          div(v-else)

            //- CommentType: "location"
            static-map(:lat="comment.payload.latitude"
              :lng="comment.payload.longitude"
              :name="comment.payload.name"
              :mapkey="core.googleMapKey"
              :message="comment.message"
              :mapurl="comment.payload.map_url"
              v-if="comment.type == 'location'")

            //- CommentType: "contact_person"
            comment-contact(v-if="comment.type == 'contact_person'"
              :comment="comment")

            //- CommentType: "file_attachment"
            file-attachment(v-if="comment.type == 'file_attachment'"
              :comment="comment"
              :on-click-image="onClickImage"
              :callback="onupdate")

            //- CommentType: "CAROUSEL"
            comment-carousel(:cards="comment.payload.cards" :mode="this.core.mode" v-if="comment.type === 'carousel'")

            //- CommentType: "CUSTOM"
            comment-custom(v-if="comment.type === 'custom' && (comment.payload && comment.payload.type !== 'email_attachment')" :data="comment")

            //- comment CommentEmailAttachment

            comment-email-attachment(v-if="comment.type === 'custom' && (comment.payload && comment.payload.type === 'email_attachment')" :comment="comment" :isMe="isMe")

            //- CommentType: "BUTTON"
            div(v-if="comment.type == 'buttons'" class="button-message" :class="{'button-message__redownload': isRedownloadButton}")
              div
                div(class="qcw-comment__content" :class="{'qcw-comment__content__redownload': isRedownloadButton}" v-html="comment.payload.text || comment.message")
                comment-buttons(:buttons="comment.payload.buttons" :postbackHandler="postbackSubmit")
                div(v-if="isRedownloadButton" class="qcw-comment__note")
                  i
                    icon(name="ic-info")
                  small You can only redownload an attachment file once

            //- CommentType: "CARD"
            comment-card(:data="comment.payload" v-if="comment.type==='card'")

            //- CommentType: "CARD"
            div(v-if="comment.type=='button_postback_response'" class="comment-text" @click.self="menuMoreClicked(null)")
              comment-render(:text="comment.message" v-if="!comment.isAttachment(comment.message) && !isRedownloadComment")
              comment-redownload(:message="comment.message+' File from '" :sender="comment.payload.payload.sender" :timestamp="comment.payload.payload.timestamp" v-if="isRedownloadComment")

            //- CommentType: "ACCOUNT_LINKING"
            div(v-if="comment.type == 'account_linking'")
              comment-render(:text="comment.payload.text || message")
              div(class="qcw-comment__buttons")
                div(class="action_buttons")
                  button(@click="openAccountBox") {{ comment.payload.params.button_text }} &rang;

            //- CommentCustom: "sticker"
            div(class="comment-sticker" v-if="comment.type == 'text' && isSticker")
              image-loader(v-if="isSticker"
                :comment="comment"
                :message="comment.message.replace('[sticker]','[file]').replace('[/sticker]','[/file]')"
                :callback="onupdate")

            //- Interactive List Message
            div(v-if="isInteractiveListMessage" class="comment-text")
              div(v-if="!comment.isAttachment(comment.message) && comment.extras" class="qcw-comment__content")
                div(v-if="comment.extras.header" class="qcw-interactive__header" v-html="comment.extras.header.value")
                div(v-if="comment.extras.body" class="qcw-interactive__body" v-html="comment.extras.body")
                div(v-if="comment.extras.footer && comment.extras.footer.text" class="qcw-interactive__footer" v-html="comment.extras.footer.text")
                div(v-if="comment.extras.action && comment.extras.action.button" class="qcw-interactive__btn" v-html="comment.extras.action.button")
                ul(v-if="comment.extras.action && comment.extras.action.sections.length > 0" v-for="(section, index) in comment.extras.action.sections" :key="index" class="qcw-interactive__section")
                  li(v-if="section.title" v-html="section.title" class="qcw-interactive__row--title qcw-interactive__bulleted--item")
                  div(v-if="section.rows.length > 0" v-for="row in section.rows" :key="row.id")
                    li(v-if="row.title" v-html="`(${row.title})`" class="qcw-interactive__row--title" :class="{'qcw-interactive__bulleted--item' : !section.title}")
                    li(v-if="row.description" v-html="row.description")

            //- Interactive Quick Reply
            div(v-if="isInteractiveQuickReply" class="comment-text")
              div(v-if="comment.extras" class="qcw-comment__content")
                file-attachment(v-if="comment.extras.header && comment.extras.header.type !== 'text'"
                  :comment="comment"
                  :on-click-image="onClickImage"
                  :callback="onupdate")
                div(v-if="comment.extras.header && comment.extras.header.type === 'text'" class="qcw-interactive__header" v-html="comment.extras.header.value")
                div(v-if="comment.extras.body" class="qcw-interactive__body" v-html="comment.extras.body")
                div(v-if="comment.extras.footer && comment.extras.footer.text" class="qcw-interactive__footer" v-html="comment.extras.footer.text")
                div(v-if="comment.extras.action && comment.extras.action.buttons.length > 0" v-for="button in comment.extras.action.buttons" :key="button.reply.id" class="qcw-interactive__btn--item")
                  div(class="qcw-interactive__btn--reply" v-html="button.reply.title")

            //- CommentType: "TEXT"
            div(class="comment-text" v-if="(comment.type == 'text' || comment.type == 'reply') && !isSticker && !isInteractiveListMessage && !isInteractiveQuickReply && !isPreviousSessionMessageNotifier")
              image-loader(v-if="comment.isAttachment(comment.message) && comment.type != 'reply'"
                :comment="comment"
                :message="comment.message"
                :on-click-image="onClickImage"
                :callback="onupdate")

              comment-reply(v-if="comment.type =='reply'"
                :comment="comment"
                :isMe="isMe"
                :clickHandler="gotoComment"
                :onClickImage="onClickImage"
                :callback="onupdate")

              comment-catalog(:catalog="comment.extras.action" v-if="comment.extras.action && comment.extras.action.catalog_id")

              comment-render(:text="comment.message" v-if="!comment.isAttachment(comment.message) && comment.type=='text'")

              comment-order(:order="comment.extras.order" v-if="comment.extras.order && comment.extras.order.catalog_id")

            div(class="comment-text" v-if="comment.type == 'text' && isPreviousSessionMessageNotifier")
              image-loader(v-if="comment.isAttachment(comment.message)"
                :comment="comment"
                :message="comment.message"
                :on-click-image="onClickImage"
                :callback="onupdate")
              comment-render(:text="comment.message" v-if="!comment.isAttachment(comment.message)")

            span(class="qcw-comment__time qcw-comment__time--children"
              v-if="!isParent"
              :class="{'qcw-comment__time--attachment': comment.isAttachment(comment.message)}") {{comment.time}}

            span(class="qcw-comment__time"
              :class="{'qcw-comment__time--me': isMe}"
              v-if="!isMe"
              :style="messageTimeStyle") {{comment.time}}

            span(class="qcw-comment__time" v-else) {{comment.time}}

            //- State
            div(v-if="isMe")
              div(class="qcw-comment__state qcw-comment__state--sending" v-if="comment.isPending")
                icon(name="ic-load" class="ic-load__state" :fill="messageStatusIconStyle")
              div(class="qcw-comment__state" v-if="!comment.isChannel && comment.isSent && !comment.isDelivered")
                icon(name="ic-check" class="ic-check__state" :fill="messageStatusIconStyle")
              div(@click="resend(comment)" class="qcw-comment__state qcw-comment__state--failed"
                v-if="comment.isFailed" :style="messageFailedIconStyle") !!!
              div(class="qcw-comment__state qcw-comment__state--delivered" v-if="!comment.isChannel && comment.status=='delivered'")
                icon(name="ic-double-check" class="ic-double-check__state" :fill="messageStatusIconStyle")
              div(class="qcw-comment__state qcw-comment__state--read" v-if="!comment.isChannel && comment.status=='read'")
                icon(name="ic-double-check" class="ic-double-check__state")

    div(class="failed-info" v-if="comment.isFailed"
      :class="{ 'failed--last': isLast }") Message failed to send.
      span(@click="resend(comment)" class="" v-if="comment.isFailed") Resend

</template>

<script>
import QiscusCore from '../lib/SDKCore';
import Avatar from './Avatar';
import Icon from './Icon';
import StaticMap from './StaticMap';
import ImageLoader from './ImageLoader';
import FileAttachment from './FileAttachment';
import CommentRender from './CommentRender';
import CommentRedownload from './CommentRedownload';
import CommentReply from './CommentReply';
import CommentCustom from './CommentCustom';
import CommentCarousel from './CommentCarousel';
import CommentCard from './CommentCard';
import CommentButtons from './CommentButtons';
import CommentContact from './CommentContact';
import CommentEmailAttachment from './CommentEmailAttachment';
import CommentFbAds from './CommentFbAds';
import clickOutside from '../lib/clickOutside';
import CommentOrder from './CommentOrder';
import CommentCatalog from './CommentCatalog';

export default {
  name: 'Comment',
  components: {
    Avatar,
    Icon,
    StaticMap,
    ImageLoader,
    FileAttachment,
    CommentRender,
    CommentRedownload,
    CommentReply,
    CommentCustom,
    CommentCarousel,
    CommentCard,
    CommentButtons,
    CommentContact,
    CommentOrder,
    CommentCatalog,
    CommentEmailAttachment,
    CommentFbAds,
  },
  props: [
    'comment',
    'commentBefore',
    'commentAfter',
    'userData',
    'onClickImage',
    'onupdate',
    'replyHandler',
    'showAvatar',
    'currentMenuId',
    'isSticker',
    'roomName',
    'stickerUrl',
    'customerEmail',
    'isInteractiveListMessage',
    'isInteractiveQuickReply',
  ],
  directives: { clickOutside },
  computed: {
    isRedownloadComment() {
      if (this.comment.payload &&
        this.comment.payload.payload &&
        this.comment.payload.payload.sub_type) {
        return this.comment.payload.payload.sub_type === 'redownload';
      }
      return false;
    },
    isRedownloadButton() {
      if (
        this.comment.type === 'buttons' &&
        this.comment.payload.buttons &&
        this.comment.payload.buttons.length > 0
      ) {
        const payload = this.comment.payload.buttons[0].payload.payload;
        if (payload) return payload.sub_type === 'redownload';
      }
      return false;
    },
    isChannel() {
      return this.comment.isChannel;
    },
    isDeleted() {
      return this.comment.is_deleted === true;
    },
    isCustomBuble() {
      return this.comment.type === 'card' || this.comment.type === 'carousel';
    },
    showDate() {
      return (
        this.commentBefore === null ||
        this.commentBefore.date !== this.comment.date
      );
    },
    addExtraMargin() {
      if (this.commentBefore === null) return false;
      let commentBeforeEmail = this.commentBefore.username_real.toString();
      let commentEmail = this.comment.username_real.toString();
      if (this.commentBefore.extras && this.commentBefore.extras.alternate_user) {
        commentBeforeEmail = this.commentBefore.extras.alternate_user.email.toString();
      }
      if (this.comment.extras && this.comment.extras.alternate_user) {
        commentEmail = this.comment.extras.alternate_user.email.toString();
      }
      return (
        commentBeforeEmail === commentEmail
      );
    },
    isPreviousSessionMessageNotifier() {
      const textToFind = 'This message was sent on previous session by';
      let placeToFind = this.comment.message;
      if (
        this.comment.type === 'file_attachment' &&
        this.comment.payload.caption
      )        { placeToFind = this.comment.payload.caption; }
      return placeToFind.includes(textToFind);
    },
    isParent() {
      if (this.commentBefore === null) return true;
      let commentBeforeEmail = this.commentBefore.username_real.toString();
      let commentEmail = this.comment.username_real.toString();
      if (this.commentBefore.extras && this.commentBefore.extras.alternate_user) {
        commentBeforeEmail = this.commentBefore.extras.alternate_user.email.toString();
      }
      if (this.comment.extras && this.comment.extras.alternate_user) {
        commentEmail = this.comment.extras.alternate_user.email.toString();
      }
      return (
        commentBeforeEmail !== commentEmail
      );
    },
    isGroupRoom() {
      return this.core.selected.room_type === 'group';
    },
    isMid() {
      if (this.commentAfter === null) return false;

      let commentAfterEmail = this.commentAfter.username_real.toString();
      let commentEmail = this.comment.username_real.toString();

      if (this.commentAfter.extras && this.commentAfter.extras.alternate_user) {
        commentAfterEmail = this.commentAfter.extras.alternate_user.email.toString();
      }
      if (this.comment.extras && this.comment.extras.alternate_user) {
        commentEmail = this.comment.extras.alternate_user.email.toString();
      }
      return (
        !this.isParent &&
        commentAfterEmail === commentEmail
      );
    },
    isLast() {
      if (this.commentAfter === null) return true;
      let commentAfterEmail = this.commentAfter.username_real.toString();
      let commentEmail = this.comment.username_real.toString();
      if (this.commentAfter.extras && this.commentAfter.extras.alternate_user) {
        commentAfterEmail = this.commentAfter.extras.alternate_user.email.toString();
      }
      if (this.comment.extras && this.comment.extras.alternate_user) {
        commentEmail = this.comment.extras.alternate_user.email.toString();
      }
      return (
        commentAfterEmail !== commentEmail
      );
    },
    isMe() {
      let usernameReal = this.comment.username_real.toString();
      let userDataEmail = this.userData.email.toString();
      if (this.comment.extras && this.comment.extras.alternate_user) {
        usernameReal = this.comment.extras.alternate_user.email.toString();
      }
      if (this.core.UI.alternateUser) {
        userDataEmail = this.core.UI.alternateUser.email.toString();
      }
      return (
        usernameReal === userDataEmail
      );
    },
    isCustomer() {
      return typeof this.comment.user_extras === 'undefined' ||
            typeof this.comment.user_extras.type === 'undefined' ||
            this.comment.user_extras.type !== 'agent';
    },
    showMenuMore() {
      if (!this.currentMenuId) return false;
      return this.comment.id === this.currentMenuId;
    },
    isReplayBot() {
      return (
        this.comment.extras &&
        Object.keys(this.comment.extras).length > 0 &&
        this.comment.extras.action === 'bot_reply'
      );
    },
    username() {
      if (this.comment.extras && this.comment.extras.alternate_user) {
        return this.comment.extras.alternate_user.name.toString();
      }
      return this.comment.username_as;
    },
    avatar() {
      if (this.comment.extras && this.comment.extras.alternate_user) {
        // console.log(this.comment);
        return this.comment.extras.alternate_user.avatar.toString();
      }
      return this.comment.avatar;
    },
    isFbAdsComment() {
      return this.comment.extras
        && this.comment.extras.referral
        && this.comment.extras.referral.source_type
        && (this.comment.extras.referral.source_type === 'ad' || this.comment.extras.referral.source_type === 'post');
    },
    isStickerAds() {
      return this.isSticker && this.isFbAdsComment;
    },
  },
  data() {
    return {
      dateToday: new Date(this.comment.date).toLocaleString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }),
      messageStyle: {},
      tipMessageStyle: {},
      messageStatusIconStyle: { fill: QiscusUI.colors.messageStatusIconColor },
      messageFailedIconStyle: { fill: QiscusUI.colors.messageFailedIconColor },
      messageTimeStyle: { color: QiscusUI.colors.messageTimeColor },
      core: QiscusCore,
    };
  },
  mounted() {
    if (!this.isCustomBuble) {
      this.messageStyle = {
        color: this.isMe
          ? this.core.UI.colors.bubleRightTextColor
          : this.core.UI.colors.bubleLeftTextColor,
        background: this.isMe
          ? this.core.UI.colors.bubleRightColor
          : this.core.UI.colors.bubleLeftColor,
      };
      this.tipMessageStyle = {
        borderLeftColor: this.isMe
          ? this.core.UI.colors.bubleRightColor
          : 'transparent',
        borderRightColor: this.isMe
          ? 'transparent'
          : this.core.UI.colors.bubleLeftColor,
      };
    }
  },
  methods: {
    renderPreviousSessionMessage(msg) {
      if (!msg.message.startsWith('[file]')) return msg.message;
      return `File Attachment: ${msg.message
        .replace('[file]', '')
        .replace('[/file]', '')
        .trim()}`;
    },
    sanitizeHTML(content) {
      return content
        ? content.replace(/</g, '&lt;').replace(/>/g, '&gt;')
        : content;
    },
    unsanitizeHTML(content) {
      return content
        ? content.replace(/(&gt;)/g, '>').replace(/(&lt;)/g, '<')
        : content;
    },
    onClickMenuOutside() {
      if (this.currentMenuId) this.menuMoreClicked(null);
    },
    gotoComment() {
      const commentId = this.comment.payload.replied_comment_id;
      const element = document.getElementById(commentId);
      let ofs = 0;
      let timer = 1;

      if (!element) {
        this.$emit('commentNotFound', commentId);
        return this.$toasted.error(
          'Comment not loaded yet, load more to go to comment',
        );
      }

      const blink = window.setInterval(() => {
        element.style.background = `rgba(255, 252, 218, ${Math.abs(
          Math.sin(ofs),
        )})`;
        ofs += 0.05;
        timer += 1;
        if (timer === 300) {
          window.clearInterval(blink);
          element.style.background = 'transparent';
        }
      }, 10);

      return element.scrollIntoView({ block: 'end', behaviour: 'smooth' });
    },
    resend(comment) {
      const commentToBeSent = Object.assign({}, comment);
      commentToBeSent.payload = JSON.stringify(commentToBeSent.payload);
      return this.core.resendComment(commentToBeSent).then(
        () => this.$toasted.success('Resending comment successful'),
        () => this.$toasted.error('Resending comment failed'),
      );
    },
    confirmDeleteComment(comment) {
      this.menuMoreClicked(null);
      const actions = [];
      actions.push({
        text: 'Yes',
        onClick: () =>
          this.deleteComment(comment, true).then(
            () => {
              this.$toasted.success('Message deleted');
            },
            () => {
              this.$toasted.error('Failed deleting message');
            },
          ),
      });
      actions.push({
        text: 'Cancel',
        onClick: (e, toastObject) => toastObject.goAway(0),
      });
      return this.$toasted.show('Are you sure to delete this message?', {
        duration: 5000,
        action: actions,
      });
    },
    deleteComment(comment, isForEveryone) {
      this.$toasted.clear();
      if (comment.isFailed) return this.deleteLocalComment(comment);
      const roomId = this.core.selected.id;
      const commentIds = [comment.unique_id];
      const commentIndex = this.core.selected.comments.findIndex(
        c => comment.unique_id === c.unique_id,
      );
      if (commentIndex && comment.before_id < 1) {
        this.core.selected.comments[commentIndex + 1].before_id = 0;
      }
      return this.core.deleteComment(roomId, commentIds, isForEveryone, true);
    },
    deleteLocalComment(comment) {
      const comments = this.core.selected.comments;
      const commentToBeFound = comments.findIndex(
        com => com.unique_id === comment.unique_id,
      );
      if (commentToBeFound > -1) comments.splice(commentToBeFound, 1);
      return Promise.resolve(comments);
    },
    haveTemplate(comment) {
      if (!this.core.customTemplate) return false;
      return this.core.templateFunction(comment);
    },
    postbackSubmit(button) {
      const roomId = this.core.selected.id;
      const labelToSend = button.postback_text
        ? button.postback_text
        : button.label;
      const nanotimestamp = (window.performance.now() + window.performance.timeOrigin);
      const uniqueId = `${roomId}_${nanotimestamp}`;
      this.core.sendComment(
        roomId,
        labelToSend,
        uniqueId,
        'button_postback_response',
        JSON.stringify(button.payload),
      )
        .then((res) => {
          this.core.options.sentMessageCallback(res);
        });
    },
    openAccountBox() {
      window.open(
        this.comment.payload.url,
        'AccountLinkingPopup',
        'width=500,height=400,location=no,menubar=no,resizable=1,status=no,toolbar=no',
      );
    },
    messageInfoHandler(comment) {
      this.core.UI.isMessageInfoActive = true;
      this.core.UI.messageInfoData = {
        comment,
      };
    },
    menuMoreClicked(id) {
      const commentId = this.currentMenuId === id ? null : id;
      this.$emit('onChangeMenu', commentId);
    },
    commentAvatar(avatar) {
      if (avatar) {
        if (avatar.includes('//image.flaticon.com/icons')) {
          return 'https://multichannel.qiscus.com/img/default_avatar.svg';
        }
        return avatar;
      }
      return this.core.avatar_url;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Comment.vue